import React, { useState, FC } from 'react';
import cn from 'clsx';

import LazyToggleContent from '../LazyToggleContent';

import useIntersection from '../../hooks/useIntersection';

import getFourUpSources from '../../utils/getPictureSourceSets';

interface Props {
  className?: string;
  imageClassName?: string;
  image: any;
  mobileImage?: any;
  // aspectRatio?: any;
  // mobileAspectRatio?: any;
  onLoad?: any;
  loadedClassName?: string;
  loadingClassName?: string;
  // preload?: boolean;
  priority?: boolean;
  alt?: string;
}

const LazyPicture: FC<Props> = ({
  alt = '',
  className,
  image,
  imageClassName,
  loadedClassName,
  loadingClassName,
  // aspectRatio,
  // mobileAspectRatio,
  onLoad,
  // preload = false,
  priority = false,
  ...props
}) => {
  const [isImageLoaded, setIsLoaded] = useState(priority);
  const [ref, inView] = useIntersection({
    triggerOnce: true,
    rootMargin: '100px 0px',
    initialInView: priority,
    skip: priority,
  });

  return (
    <div
      className={cn('relative', className, isImageLoaded ? loadedClassName : loadingClassName)}
      ref={ref}
    >
      <LazyToggleContent show={isImageLoaded || priority || inView}>
        <picture className={imageClassName}>
          {getFourUpSources(image)}
          <img
            alt={alt}
            className={imageClassName}
            // @ts-expect-error
            importance={priority ? 'high' : 'auto'}
            onLoad={() => {
              setIsLoaded(true);
              onLoad && onLoad(true);
            }}
            src={image}
            {...props}
          />
        </picture>
      </LazyToggleContent>
    </div>
  );
};

export default LazyPicture;
